<template>
    <div class="container-fluid">
        <div><h3>Feriados</h3></div>
        <form v-on:submit.prevent="create" class="row">
            <div class="form-group col-md-4">
                <input class="form-control" id="name" v-model="name" ref="name" placeholder="Nome"/>
            </div>
            <div class="form-group col-md-3">
                <span class="holiday-date">Data:</span>
                <date-picker
                    v-model ="holidayDate"
                    format="DD/MMMM"
                >
                </date-picker>
            </div>
            <div class="form-group col-md-1">
                <input class="form-control" id="year" v-model="year" ref="year" placeholder="Ano"/>
            </div>
            <div class="col-md-4">
                <button type="submit" class="btn btn-success">Salvar</button>
            </div>
        </form>
        <ul class="crud-pills nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active" id="active-tab" data-bs-toggle="pill" data-bs-target="#active" type="button" role="tab" aria-controls="active" aria-selected="true">Ativas</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="disabled-tab" data-bs-toggle="pill" data-bs-target="#disabled" type="button" role="tab" aria-controls="disabled" aria-selected="false">Desativadas</button>
            </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Data</th>
                        <th>Ano</th>
                        <th width="120px">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="holiday in holidays" :key="holiday.id">
                        <td><input class="form-control hide-input" v-model="holiday.name" v-on:blur="edit(holiday)"></td>
                        <td>
                            <date-picker
                                v-model ="holiday.date"
                                format="DD/MMMM"
                                v-on:change="edit(holiday)"
                            >
                            </date-picker>
                        </td>
                        <td><input class="form-control hide-input" v-model="holiday.year" v-on:blur="edit(holiday)"></td>
                        <td>
                            <button class="btn btn-danger" v-on:click="destroy(holiday.id)"><i class="far fa-trash-alt"></i></button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="tab-pane fade" id="disabled" role="tabpanel" aria-labelledby="disabled-tab">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Data</th>
                        <th width="120px">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="holiday in deletedHolidays" :key="holiday.id">
                        <td><input class="form-control hide-input" v-model="holiday.name" v-on:blur="edit(holiday)"></td>
                        <td>
                            <date-picker
                                v-model ="holiday.date"
                                format="DD/MMMM"
                                v-on:change="edit(holiday)"
                            >
                            </date-picker>
                        </td>
                        <td>
                            <button class="btn btn-success" v-on:click="activate(holiday.id)"><i class="fas fa-check"></i></button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import DatePicker from 'vue2-datepicker'

    export default {
        name: 'Holidays',
        components: {
            DatePicker
        },
        data () {
            return {
                holidays: {},
                name: '',
                year: null,
                errors: {},
                deletedHolidays: {},
                holidayDate: new Date()
            }
        },
        mounted (){
            this.index()
            this.deleted()
        },
        methods: {
            create () {
                let data = new FormData()

                data.append('name', this.name)
                data.append('day', this.holidayDate.getDate())
                data.append('month', this.holidayDate.getMonth() + 1)
                if (this.year) {
                    data.append('year', this.year)
                }

                axios.post('/api/holidays', data)
                    .then(() => {
                        this.name = ''
                        this.year = ''
                        this.$refs.name.focus()
                        this.index()
                        this.errors = {}
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors
                        let message = ''
                        for (var i in this.errors) {
                            message = this.errors[i] + '<br />' + message
                        }
                        this.$swal({
                            title: 'Ops...',
                            text: message,
                            icon: 'error',
                            html: message
                        }).then(() => {
                            this.index()
                            this.deleted()
                        })
                    })
            },
            index () {
                axios
                    .get('/api/holidays')
                    .then((response) => {
                        this.holidays = response.data.data
                        for (let index in this.holidays) {
                            this.holidays[index].date = new Date(this.holidays[index].date + ' 12:00:00')
                        }
                    })
            },
            destroy (id) {
                this.$confirm(
                    {
                        message: `Tem certeza que deseja excluir?`,
                        button: {
                            no: 'Não',
                            yes: 'Sim'
                        },
                        callback: confirm => {
                            if (confirm) {
                                axios.delete('/api/holidays/' + id)
                                    .then(() => {
                                        this.index()
                                        this.deleted()
                                    })
                            }
                        }
                    }
                )
            },
            edit (holiday) {
                let data = new FormData()

                data.append('_method', 'PUT')
                data.append('name', holiday.name)
                data.append('day', holiday.date.getDate())
                data.append('month', holiday.date.getMonth() + 1)
                if (this.year) {
                    data.append('year', holiday.year)
                }
                axios.post('/api/holidays/' + holiday.id, data)
                    .then(() => {
                        this.index()
                    })
                    .catch((error) => {
                        this.errorsEdit = error.response.data.errors
                        let message = ''
                        for (var i in this.errorsEdit) {
                            message = this.errorsEdit[i] + '<br />' + message
                        }
                        this.$swal({
                            title: 'Ops...',
                            text: message,
                            icon: 'error',
                            html: message
                        }).then(() => {
                            this.index()
                            this.deleted()
                        })
                    })
            },
            deleted () {
                axios
                    .get('/api/holidays/deleted')
                    .then((response) => {
                        this.deletedHolidays = response.data.data
                        for (let index in this.deletedHolidays) {
                            this.deletedHolidays[index].date = new Date(this.deletedHolidays[index].date + ' 12:00:00')
                        }
                    })
            },
            activate (id) {
                this.$confirm(
                    {
                        message: `Tem certeza que deseja reativar?`,
                        button: {
                            no: 'Não',
                            yes: 'Sim'
                        },
                        callback: confirm => {
                            if (confirm) {
                                axios.put('/api/holidays/activate/' + id)
                                    .then(() => {
                                        this.index()
                                        this.deleted()
                                    })
                            }
                        }
                    }
                )
            }
        }
    }
</script>

<style scoped lang="sass">
    .holiday-date
        margin-right: 10px
</style>
